var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 14.7867,
    cy: 14.2474,
    r: 11.0402,
    transform: "rotate(-0.552216 14.7867 14.2474)",
    fill: "#F8CA50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.891 25.2845C20.9614 25.226 25.8801 20.2115 25.8216 14.1412C25.7631 8.07082 20.7486 3.15205 14.6783 3.21056C8.60795 3.26907 3.68918 8.28358 3.74768 14.3539C3.80619 20.4243 8.8207 25.343 14.891 25.2845ZM14.6517 0.451318C22.2396 0.378183 28.5077 6.52665 28.5809 14.1146C28.654 21.7025 22.5056 27.9706 14.9176 28.0438C7.32971 28.1169 1.06158 21.9684 0.988441 14.3805C0.915306 6.79259 7.06377 0.524452 14.6517 0.451318ZM21.708 16.8023L20.7596 18.6052L13.409 14.6747L13.3386 7.36273L15.408 7.34278L15.4665 13.4131L21.708 16.8023Z",
    fill: "#F8CA50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/Pending.6c9699cb2dfd9e74705cfe6d8fb78f03.svg";
export { ForwardRef as ReactComponent };